














import Vue from 'vue';
import { ButtonModel, EntityType } from '@/types';
import EntityLockModal from '@/components/shared/EntityLockModal.vue';

export default Vue.extend({
  name: 'DocumentLock',
  props: {
    lastActivity: {
      type: Date,
      required: true
    }
  },
  methods: {
    onButtonClicked(this: any, button: ButtonModel) {
      this.$emit('buttonClicked', button.id);
    },
  },
  created(this: any) {
    this.buttons = [
      {
        caption: 'Return to documents to store',
        id: 'returnToDocumentsToStore',
        class: 'mr-2',
        icon: 'undo-alt',
        variant: 'primary'
      }
    ] as ButtonModel[];

    this.entityType = EntityType.Document;
    this.routeName = 'storeDocuments';
    this.routeText = 'Return to documents to store';
    this.returnRouteDesc = 'documents to store page';
    this.storeNamespace = 'documentToStoreStore';
  },
  components: {
    EntityLockModal
  }
});
